import React from "react";
import { Col, Form, Row } from "react-bootstrap";

const VillageAddress = ({ villageAddressData, loader }) => {
  return (
    <div className="wrapper mw-100 position-relative mb-5 pb-2 px-md-4 px-3">
      <span className="wrapper-heading">Village Residence Information</span>

      <Row className="mb-3 gx-sm-3 gx-2">
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Address Line 1</Form.Label>
            <div>{villageAddressData?.villageAddress?.line1 || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">Address Line 2 </Form.Label>
            <div>{villageAddressData?.villageAddress?.line2 || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group controlId="formSurname">
            <Form.Label className="fw-bold">District</Form.Label>
            <div>{villageAddressData?.villageAddress?.district || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label className="fw-bold">City</Form.Label>
            <div>{villageAddressData?.villageAddress?.city || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formYearOfBirth">
            <Form.Label className="fw-bold">State</Form.Label>
            <div>{villageAddressData?.villageAddress?.state || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Country</Form.Label>
            <div>{villageAddressData?.villageAddress?.country || "-"}</div>
          </Form.Group>
        </Col>

        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Landmark</Form.Label>
            <div>{villageAddressData?.villageAddress?.landmark || "-"}</div>
          </Form.Group>
        </Col>
        <Col xl={3} md={4} sm={6} className="mb-3">
          <Form.Group className="" controlId="formEmail">
            <Form.Label className="fw-bold">Pin-code</Form.Label>
            <div>{villageAddressData?.villageAddress?.pinCode || "-"}</div>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default VillageAddress;
